import axios from 'axios';
import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

export const generateMonthlyReports = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.GenerateReports.MONTHLY,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};


export const getMonthlyFilesCount = async ({ month, year }) => {
  return axios({
    method: 'get',
    url: endpoints.GenerateReports.MONTHLY_COUNT,
    baseURL: baseUrl,
    params: { month, year },
  }).then((response) => Number(response.data.result.count)); 
};
